import Pathes from '@/helpers/pathes';
import axios from '@/axios-api';
import { getQuery } from '@/helpers/utils.jsx';

export const fundraisingService = {
  status: () => axios.get(Pathes.Fundraising.status),
  statusById: fundraisingId => axios.get(Pathes.Fundraising.statusById(fundraisingId)),
  riskFactorStatus: () => axios.get(Pathes.Fundraising.riskFactorStatus),
  coFoundersList: () => axios.get(Pathes.Founders.coFounders),
  tariffPlans: params => axios.get(Pathes.Fundraising.tariffPlans + getQuery(params)),
  resetFundraising: () => axios.post(Pathes.Fundraising.resetFundraising),
  fundraisingRecalculation: (payload, params) =>
    axios.post(Pathes.Fundraising.fundraisingRecalculation + getQuery(params), payload),
  fundraisingDates: () => axios.get(Pathes.Dashboard.fundraisingDates),
  setFundraising: payload => axios.post(Pathes.Fundraising.setGoal, payload),
  confirmFundraising: payload => axios.post(Pathes.Fundraising.acceptOrDeclineFundraising, payload),
  nextStatus: () => axios.get(Pathes.Fundraising.nextStatus),
  saveFpgAssets: payload => axios.post(Pathes.Fundraising.fpgAssets, payload),
  application: params => axios.get(Pathes.Fundraising.application + getQuery(params)),
  submitApplication: (applicationId, payload) =>
    axios.post(Pathes.Fundraising.applicationSubmit(applicationId), payload),
  applicationStatus: () => axios.get(Pathes.Fundraising.applicationStatus),
  applicationStatusById: applicationId =>
    axios.get(Pathes.Fundraising.applicationStatusById(applicationId)),
  applicationList: () => axios.get(Pathes.Fundraising.applicationList),
  createApplication: payload => axios.post(Pathes.Fundraising.applicationCreate, payload),
  founderFundraisingStatus: founderId => axios.get(Pathes.Founders.fundraisingStatus(founderId)),
  lenderApplicationList: () => axios.get(Pathes.Fundraising.lenderApplicationList),
  lenderSetFundraising: payload => axios.post(Pathes.Fundraising.lenderSetGoal, payload),
  lenderResetFundraising: payload => axios.post(Pathes.Fundraising.lenderResetFundraising, payload),
  borrowerConfirmFundraising: payload =>
    axios.post(Pathes.Fundraising.borrowerConfirmFundraising, payload),
  lenderFundraisingStatus: companyId =>
    axios.get(Pathes.Fundraising.lenderFundraisingStatus(companyId)),
  lenderSaveFpgAssets: payload => axios.post(Pathes.Fundraising.lenderFpgAssets, payload),
};